import React from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

// Import all setting pages
import SchoolsSetting from "./SettingPages/SchoolSetting/pages/SchoolsSetting";
import RequiredDocument from "./SettingPages/StudentSetting/pages/RequiredDocument";
import NotFound from "./SettingPages/NotFound/NotFound";
import GeneralSetting from "./SettingPages/SchoolSetting/pages/GeneralSetting";
import WhatsAppSetting from "./SettingPages/CommunicationSetting/WhatsAppSetting";
import SerialNumber from "./SettingPages/SchoolSetting/pages/SerialNumber/SerialNumber";
import ParentDeclaration from "./SettingPages/StudentSetting/pages/ParentDeclaration";

const SettingPageContainer = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  const getSettingPageComponent = (route) => {
    switch (route) {
      // Student Setting routes
      case "/settings/studentSetting/requiredDocument":
        return <RequiredDocument />;
      case "/settings/studentSetting/parentDecleration":
        return <ParentDeclaration />;

      // School Setting routes
      case "/settings/schoolSetting/school":
        return <SchoolsSetting />;
      case "/settings/schoolSetting/general":
        return <GeneralSetting />;
      case "/settings/schoolSetting/serialNumber":
        return <SerialNumber />;

      // Communication Setting routes
      case "/settings/communicationSetting/whatsapp":
        return <WhatsAppSetting />; // Placeholder for WhatsApp settings page
      default:
        return <NotFound />;
    }
  };

  if (!currentPath || currentPath === "/settings") {
    return (
      <Box
        sx={{
          p: 4,
          textAlign: "center",
          color: "text.secondary",
        }}
      >
        Please select a setting category from the sidebar to get started.
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "auto",
        p: 0,
      }}
    >
      {getSettingPageComponent(currentPath)}
    </Box>
  );
};

export default SettingPageContainer;
